module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "legalCasePersonOrgDash"
    }
  }, [_c('FormSection', {
    attrs: {
      "label": "Case",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "legal_case_table",
    attrs: {
      "id": "legal-case-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00fa79bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/legal_case_person_org_dashboard.vue
// module id = 909
// module chunks = 0